import { z } from 'zod'

import { ERROR_MESSAGES } from '../consts'

export const CheckoutSchema = z.object({
  firstName: z.string().min(2, ERROR_MESSAGES.firstName),
  lastName: z.string().min(2, ERROR_MESSAGES.lastName),
  cardNumber: z
    .object({
      valid: z.boolean(),
      empty: z.boolean(),
      brand: z.string().optional(),
    })
    .refine((data) => data.valid, {
      message: ERROR_MESSAGES.cardNumber,
    }),
  expiryMonth: z
    .object({
      valid: z.boolean(),
    })
    .refine((data) => data.valid, {
      message: ERROR_MESSAGES.expiryMonth,
    }),
  expiryYear: z
    .object({
      valid: z.boolean(),
    })
    .refine((data) => data.valid, {
      message: ERROR_MESSAGES.expiryYear,
    }),
  cvv: z
    .object({
      valid: z.boolean(),
    })
    .refine((data) => data.valid, {
      message: ERROR_MESSAGES.cvv,
    }),
  country: z.object({
    value: z.string().min(1, ERROR_MESSAGES.country),
    label: z.string().min(1, ERROR_MESSAGES.country),
    id: z.number().min(1, ERROR_MESSAGES.country),
    icon: z.any(),
  }),
  postalCode: z.string().min(2, ERROR_MESSAGES.postalCode),
})

export type CheckoutFormValues = z.infer<typeof CheckoutSchema>
